import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslations } from "../../../../providers/useTranslations";
import { validationPatterns } from "../../../../utils/validationPatterns";
import { ConsentCheckbox } from "../ConsentCheckbox/ConsentCheckbox";
import { FormCheckbox } from "../FormCheckbox/FormCheckbox";
import { FormSelect } from "../FormSelect/FormSelect";
import { FormTextArea } from "../FormTextArea/FormTextArea";
import { FormTextInput } from "../FormTextInput/FormTextInput";
export const FormElement = ({ formField, formConfig, inputType }) => {
    const { __ } = useTranslations();
    const { validation, matchingFieldId, requiredMessage, required, fieldDoesNotMatchMessage, errorMessage, maxLength, minLength, ...props } = formField;
    const patterns = {
        email: validationPatterns.EMAIL_PATTERN,
        phone: validationPatterns.PHONE_CONTACT_FORM_REGEX,
    };
    const validationRules = {
        required: required ? requiredMessage || __("contact.form.requiredmessage") : false,
        maxLength: maxLength ? Number(maxLength) : undefined,
        minLength: minLength ? Number(minLength) : undefined,
        pattern: validation ? { value: patterns[validation], message: errorMessage } : undefined,
    };
    const inputConfig = { formConfig, validationRules, ...props };
    switch (inputType) {
        case "checkbox":
            return (_jsx(FormCheckbox, { id: inputConfig.id, label: inputConfig.label, isCheckedByDefault: inputConfig.checked, validationRules: validationRules, dataTestId: inputConfig.dataTestId }));
        case "consentcheckbox":
            return (_jsx(ConsentCheckbox, { displayConsent: inputConfig.displayConsent, consent: inputConfig.consent || "contact_form", dataTestId: inputConfig.dataTestId }));
        case "textarea":
            return (_jsx(FormTextArea, { id: inputConfig.id, label: inputConfig.label, placeholder: inputConfig.placeholder, validationRules: validationRules, dataTestId: inputConfig.dataTestId }));
        case "select":
            return (_jsx(FormSelect, { id: inputConfig.id, label: inputConfig.label, placeholder: inputConfig.placeholder, validationRules: validationRules, dropdownValues: inputConfig.options, dataTestId: inputConfig.dataTestId }));
        case "textinput":
        default:
            return (_jsx(FormTextInput, { id: inputConfig.id, label: inputConfig.label, placeholder: inputConfig.placeholder, matchingFieldId: matchingFieldId, mathchingFieldErrorMessage: fieldDoesNotMatchMessage, validationRules: validationRules, disclaimer: inputConfig.disclaimer, dataTestId: inputConfig.dataTestId }));
    }
};
//# sourceMappingURL=FormElement.js.map